<template>
  <!-- lr0041 -->
  <div>
    <a-form label-width="110px" class="UniformCss">
      <a-row :gutter="5">
        <a-col :span="4">
          <a-form-item label="订单编号">
            <a-input v-model="data.applyOrderCode" placeholder="请输入订单编号" clearable />
          </a-form-item>
        </a-col>
        <a-col :span="4">
          <a-form-item label="申领部门">
            <a-input v-model="data.orgName" placeholder="请输入申领部门名称" clearable />
          </a-form-item>
        </a-col>

        <a-col :span="4">
          <a-form-item label="申领人">
            <a-input v-model="data.applyMan" placeholder="请输入申领人" clearable />
          </a-form-item>
        </a-col>
        <a-col :span="4">
          <a-form-item label="申领日期">
            <a-date-picker
                valueFormat="YYYY-MM-DD"
                v-model="data.beginApplyTime"
                picker="date"
                placeholder="选择日期"
            />
          </a-form-item>
        </a-col>
        <a-col :span="4">
          <a-form-item label="至">
            <a-date-picker
                valueFormat="YYYY-MM-DD"
                v-model="data.endApplyTime"
                picker="date"
                placeholder="选择日期"
                :picker-options="{ disabledDate: time => time.getTime() < new Date(data.beginApplyTime) - 8.64e7 }"
            />
          </a-form-item>
        </a-col>
        <a-col :span="4">
          <a-form-item label="审批通过日期">
            <a-date-picker
                valueFormat="YYYY-MM-DD"
                v-model="data.beginApproveCommitDate"
                picker="date"
                placeholder="选择日期"
            />
          </a-form-item>
        </a-col>
        <a-col :span="4">
          <a-form-item label="至">
            <a-date-picker
                valueFormat="YYYY-MM-DD"
                v-model="data.endApproveCommitDate"
                picker="date"
                placeholder="选择日期"
                :picker-options="{ disabledDate: time => time.getTime() < new Date(data.beginApproveCommitDate) - 8.64e7 }"
            />
          </a-form-item>
        </a-col>
        <a-col :span="4">
          <a-form-item label="签收时间">
            <a-date-picker
                valueFormat="YYYY-MM-DD"
                v-model="data.beginReceivetime"
                picker="date"
                placeholder="选择日期"
            />
          </a-form-item>
        </a-col>
        <a-col :span="4">
          <a-form-item label="至">
            <a-date-picker
                valueFormat="YYYY-MM-DD"
                v-model="data.endReceivetime"
                picker="date"
                placeholder="选择日期"
                :picker-options="{ disabledDate: time => time.getTime() < new Date(data.beginReceivetime) - 8.64e7 }"
            />
          </a-form-item>
        </a-col>
        <a-col :span="4">
          <a-form-item label="订单状态">
            <a-select v-model="data.orderStatus" placeholder="订单状态" clearable>
              <a-select-option
                v-for="item in list.PromotionOrderStatus"
                :key="item.code"
                :value="item.code"
              >{{ item.value }}</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>


        <!-- <a-col :span="6">
          <a-form-item label="订单号">
            <a-input v-model="data.applyOrderCode" placeholder="请输入订单号" clearable />
          </a-form-item>
        </a-col> -->
        <!-- <a-col :span="6">
          <a-form-item label="提交日期">
            <a-date-picker
              valueFormat="YYYY-MM-DD"
              v-model="data.beginCommittime"
              picker="date"
              placeholder="选择日期"
            />
          </a-form-item>
        </a-col>
        <a-col :span="6">
          <a-form-item label="至">
            <a-date-picker
              valueFormat="YYYY-MM-DD"
              v-model="data.endCommittime"
              picker="date"
              placeholder="选择日期"
              :picker-options="{ disabledDate: time => time.getTime() < new Date(data.beginCommittime) - 8.64e7 }"
            />
          </a-form-item>
        </a-col> -->
       
        <!-- <a-col :span="6">
          <a-form-item label="领料人">
            <a-input v-model="data.drawMan" placeholder="请输入领料人" clearable />
          </a-form-item>
        </a-col>
        <a-col :span="6">
          <a-form-item label="首次保存日期">
            <a-date-picker
              valueFormat="YYYY-MM-DD"
              v-model="data.beginSavetime"
              picker="date"
              placeholder="选择日期"
            />
          </a-form-item>
        </a-col>
        <a-col :span="6">
          <a-form-item label="至">
            <a-date-picker
             valueFormat="YYYY-MM-DD"
              v-model="data.endSavetime"
              picker="date"
              placeholder="选择日期"
              :picker-options="{ disabledDate: time => time.getTime() < new Date(data.beginSavetime) - 8.64e7 }"
            />
          </a-form-item>
        </a-col> -->
       
        <!-- <a-col :span="6">
          <a-form-item label="审核日期">
            <a-date-picker
             valueFormat="YYYY-MM-DD"
              v-model="data.beginApprovedtime"
              picker="date"
              placeholder="选择日期"
            />
          </a-form-item>
        </a-col>
        <a-col :span="6">
          <a-form-item label="至">
            <a-date-picker
              valueFormat="YYYY-MM-DD"
              v-model="data.endApprovedtime"
              picker="date"
              placeholder="选择日期"
              :picker-options="{ disabledDate: time => time.getTime() < new Date(data.beginApprovedtime) - 8.64e7 }"
            />
          </a-form-item>
        </a-col> -->
       
      </a-row>
    </a-form>
  </div>
</template>

<script>
export default {
  name: 'SiftMaterialRequisition',
  components: {
  },
  // eslint-disable-next-line vue/require-prop-types
  props: ['data', 'list'],
  data() {
    return {
    }
  },
  computed: {},
  created() {},
  beforeMount() {},
  mounted() {},
  methods: {
  }
}
</script>
<style lang="less" scoped>
</style>
